import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { ExhaustGasSetting } from 'icreate/common/models/exhaust-gas-setting';
import { lastValueFrom } from 'rxjs';
import { SocketMiddlewareService } from './socket-middleware.service';
import { ExhaustGasSettingEvents } from 'icreate/common/io-event/websocket-message';

@Injectable({
    providedIn: 'root',
})
export class ExhaustGasSettingService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(
        private http: HttpClient,
        private socketService: SocketMiddlewareService
    ) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getSettings(vesselId: string): Promise<ExhaustGasSetting[]> {
        return await lastValueFrom(
            this.http.get<ExhaustGasSetting[]>(`${this.domain}/api/exhaust-gas-setting`, {
                headers: this.headers,
                params: { vesselId },
            })
        );
    }

    async upsert(exhaustGasSettings: ExhaustGasSetting[], vesselId: string) {
        return await lastValueFrom(
            this.http.put(
                `${this.domain}/api/exhaust-gas-setting`,
                { exhaustGasSettings, vesselId },
                {
                    headers: this.headers,
                }
            )
        );
    }

    settingsUpdated$() {
        return this.socketService.receiveMessageObserver(ExhaustGasSettingEvents.UPDATED);
    }
}
